module.exports = __webpack_public_path__ + "static/carlsbad-5-fae29e53c94fdd2b0a7baecbf9636910.png";